module.exports = __webpack_public_path__ + "media/06.929ee716.mp3";